module.exports = __webpack_public_path__ + "img/btn1.476c0fc1.png";